define(function (require) {
    "use strict";

    var Settings = require("codeTables/settings.json");

    var ENABLED_VALUE = "true";
    var SessionModel = require("models/SessionModel");

    var cobrowseSettings = (function () {

        var currentProfile;
        var currentAgentCanChooseProfile;
        var currentCoBrowseDisabled;
        var currentCoAppEnabled;
        var currentCoAppSettings;

        var getAgentCanChooseProfile = function () {
            if (_.isUndefined(currentAgentCanChooseProfile)) {
                setAgentCanChooseProfile(_getSetting(Settings.SETTING_ID.COBROWSE_CHOOSEAGENTPROFILE, true) === ENABLED_VALUE);
            }
            return currentAgentCanChooseProfile;
        };

        var getProfile = function () {
            if (_.isUndefined(currentProfile)) {
                setProfile(_getSetting(Settings.SETTING_ID.COBROWSE_AGENTPROFILE, true));
            }
            return currentProfile;
        };

        var isCoBrowseDisabled = function () {
            if (_.isUndefined(currentCoBrowseDisabled)) {
                setCoBrowseDisabled(_getSetting(Settings.SETTING_ID.COBROWSE_DISABLED, false) === ENABLED_VALUE);
            }
            return currentCoBrowseDisabled;
        };

        var isCoAppEnabled = function () {
            if (_.isUndefined(currentCoAppEnabled)) {
                currentCoAppEnabled = _getSetting(SessionModel.ACCOUNT_SETTINGS_ID.COAPP_ENABLED, false) === ENABLED_VALUE;
                setCoAppEnabled(currentCoAppEnabled);
            }
            return currentCoAppEnabled;
        };

        var getCoAppSettings = function(){
            if (_.isUndefined(currentCoAppSettings)) {
                currentCoAppSettings = _getSetting(SessionModel.ACCOUNT_SETTINGS_ID.COAPP_SETTINGS, false);
                setCoAppSettings(currentCoAppSettings);
            }
            return currentCoAppSettings;
        };

        var isPresetEnabled = function(preset){
            if (!_.isEmpty(getCoAppSettings()) && preset) {
                var presets = getCoAppSettings().presets;
                if(!_.isEmpty(presets)){
                    return presets[preset];
                }
            }
            return false;
        };

        var setAgentCanChooseProfile = function (agentCanChoose) {
            currentAgentCanChooseProfile = agentCanChoose;
        };

        var setProfile = function (profile) {
            currentProfile = profile;
        };

        var setCoBrowseDisabled = function (disabled) {
            currentCoBrowseDisabled = disabled;
        };

        var setCoAppEnabled = function (enabled) {
            currentCoAppEnabled = enabled;
        };

        var setCoAppSettings = function (settings) {
            currentCoAppSettings = settings;
        };

        var setValuesFromModel = function (model) {
            _.each(model, function (setting) {
                switch (setting.id) {
                    case Settings.SETTING_ID.COBROWSE_AGENTPROFILE:
                        setProfile(atob(setting.propertyValue.value));
                        break;
                    case Settings.SETTING_ID.COBROWSE_CHOOSEAGENTPROFILE:
                        setAgentCanChooseProfile(atob(setting.propertyValue.value) === ENABLED_VALUE);
                        break;
                    case Settings.SETTING_ID.COBROWSE_DISABLED:
                        setCoBrowseDisabled(setting.propertyValue.value === ENABLED_VALUE);
                        break;
                }
            });
        };

        var _getSetting = function (id, isBase64) {
            var property =  LE.sessionManager.getAccountSettingByID(id);
            if (property && !property.deleted && property.propertyValue && property.propertyValue.value) {
                if (isBase64) {
                    return atob(property.propertyValue.value);
                } else {
                    return property.propertyValue.value;
                }
            }
        };


        var coapp = {
            isEnabled: isCoAppEnabled,
            getSettings: getCoAppSettings,
            isPresetEnabled: isPresetEnabled
        };

        return {
            getProfile: getProfile,
            getAgentCanChooseProfile: getAgentCanChooseProfile,
            isCoBrowseDisabled: isCoBrowseDisabled,
            setProfile: setProfile,
            setAgentCanChooseProfile: setAgentCanChooseProfile,
            setCoBrowseDisabled: setCoBrowseDisabled,
            setValuesFromModel: setValuesFromModel,

            appEngagement: coapp
        };
    })();

    return cobrowseSettings;
});
